export const INLINE_BLANK_TOKEN_REGEX = /\{\{blank(?:_[^}]+)?\}\}/;

export const BLANK_ID_GLOBAL_REGEX = /\{\{blank_([^}]+)\}\}/g;

export const normalizeEscapedInlineBlankTokensInText = (text: string): string =>
	text.replace(
		/(?:\\)?\{(?:\\)?\{blank(?:\\)?_([^}]+)\}\}/g,
		(_, suffix) => `{{blank_${suffix.replace(/\\/g, "")}}}`,
	);
